import { Fragment, useState } from "react";
import styles from "./TestimonialTable.module.scss";
import Button from "../../../../../components/Button/Button";
import {
  approveTestimonial,
  deleteTestimonial,
  rejectTestimonial,
} from "../../../../../api/testimonial";
import ModalConfirmation from "../../../../../components/Modal/ModalConfirmation";

function TestimonialTable({ testimonials, setTestimonials }) {
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [testimonialIdToDelete, setTestimonialIdToDelete] = useState(null);

  const getStatus = (testimonial) => {
    if (!testimonial.isProcessed) {
      return "En attente";
    } else {
      return testimonial.isValid ? "Validé" : "Refusé";
    }
  };

  const handleDelete = async (testimonialId) => {
    try {
      await deleteTestimonial(testimonialId);

      const updatedTestimonials = testimonials.filter(
        (testimonial) => testimonial.id !== testimonialId,
      );

      setTestimonials(updatedTestimonials);

      setShowDeleteConfirmationModal(false);
    } catch (error) {
      console.error("Erreur lors de la suppression du thème : ", error);
    }
  };

  const handleApprove = async (testimonialId) => {
    try {
      const response = await approveTestimonial(testimonialId);
      if (response.status === 200) {
        console.log("Témoignage approuvé");

        const updatedTestimonials = testimonials.map((testimonial) =>
          testimonial.id === testimonialId
            ? { ...testimonial, isProcessed: true, isValid: true }
            : testimonial,
        );
        setTestimonials(updatedTestimonials);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleReject = async (testimonialId) => {
    try {
      const response = await rejectTestimonial(testimonialId);
      if (response.status === 200) {
        const updatedTestimonials = testimonials.map((testimonial) =>
          testimonial.id === testimonialId
            ? { ...testimonial, isProcessed: true, isValid: false }
            : testimonial,
        );
        setTestimonials(updatedTestimonials);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <table className={styles.container}>
        <thead>
          <tr>
            <th>Nom prénom</th>
            <th>Email</th>
            <th>Témoignages</th>
            <th>Statut</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {testimonials &&
            testimonials.map((testimonial) => (
              <Fragment key={testimonial.id}>
                <tr>
                  <td>
                    {testimonial.lastName} {testimonial.firstName}
                  </td>
                  <td>{testimonial.email}</td>
                  <td className={styles.justify}>
                    {testimonial.testimonialText}
                  </td>
                  <td>{getStatus(testimonial)}</td>
                  <td>
                    {testimonial.isProcessed ? (
                      <div className={styles.btnContainer}>
                        <Button
                          fontSize="0.8rem"
                          buttonStyle={{
                            padding: "5px 10px",
                          }}
                          onClick={() => {
                            setTestimonialIdToDelete(testimonial.id);
                            setShowDeleteConfirmationModal(true);
                          }}
                          color="#dc2626"
                        >
                          Supprimer
                        </Button>
                      </div>
                    ) : (
                      <div className={styles.btnContainer}>
                        <Button
                          fontSize="0.8rem"
                          buttonStyle={{
                            marginRight: "5px",
                            padding: "5px 10px",
                          }}
                          onClick={() => handleApprove(testimonial.id)}
                          color="var(--secondary-color)"
                        >
                          Valider
                        </Button>
                        <Button
                          fontSize="0.8rem"
                          buttonStyle={{
                            marginLeft: "5px",
                            padding: "5px 10px",
                          }}
                          onClick={() => handleReject(testimonial.id)}
                          color="var(--primary-color)"
                        >
                          Refuser
                        </Button>
                      </div>
                    )}
                  </td>
                </tr>
              </Fragment>
            ))}
        </tbody>
      </table>

      <ModalConfirmation
        isOpen={showDeleteConfirmationModal}
        onClose={() => setShowDeleteConfirmationModal(false)}
        message="Êtes-vous sûr de vouloir supprimer ce témoignage ?"
        onConfirm={() => {
          handleDelete(testimonialIdToDelete);
          setShowDeleteConfirmationModal(false);
        }}
      />
    </>
  );
}

export default TestimonialTable;
